<template>
  <div class="min-h-screen">
    <!-- Banner区域 -->
    <div class="relative h-[500px]">
      <swiper :options="swiperOption" class="h-full">
        <swiper-slide v-for="(slide, index) in bannerSlides" :key="index">
          <div class="relative h-full">
            <img :src="slide.image" class="w-full h-full object-cover" alt="banner" />
            <div class="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-start">
              <div class="container mx-auto px-8">
                <h2 class="text-4xl font-bold text-white mb-4">{{ slide.title }}</h2>
                <p class="text-xl text-white">{{ slide.description }}</p>
              </div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <h1 class="text-3xl font-bold m-4 text-center">滋賀営業所</h1>
    <div class="container mx-auto px-4 py-12">
      <!-- 新着情報 -->
      <div class="mb-16">
        <div class="flex items-center justify-between mb-12">
          <h2 class="text-3xl font-bold">新着情報</h2>
          <router-link to="/news" class="flex items-center text-[#81C784] hover:text-[#2E7D32] transition-colors duration-300">
            <span class="mr-2">More</span>
            <i class="fas fa-chevron-right text-sm"></i>
          </router-link>
        </div>
        <div v-if="newsLoading" class="flex justify-center items-center py-12">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-[#2E7D32]"></div>
        </div>
        <div v-else-if="newsError" class="bg-red-50 p-4 rounded-lg">
          <p class="text-red-600">{{ newsError }}</p>
        </div>
        <div v-else class="bg-white rounded-lg shadow-lg p-6 border border-gray-100">
          <div class="space-y-6">
            <div v-for="notice in latestNotices" :key="notice.id" class="pb-4 border-b border-gray-200 last:border-b-0 hover:bg-gray-50 p-4 rounded-lg transition-colors duration-200">
              <div class="flex items-center mb-2">
                <span class="text-[#81C784] font-semibold">{{ formatDate(notice.date) }}</span>
                <span class="mx-4 text-gray-300">|</span>
                <span class="bg-[#E8F5E9] text-[#2E7D32] px-3 py-1 rounded-full text-sm">{{ notice.category }}</span>
              </div>
              <h3 class="text-lg font-semibold mb-2">{{ notice.title }}</h3>
              <p class="text-gray-600" v-html="notice.content"></p>
            </div>
          </div>
        </div>
      </div>
      <!-- スクラップ買取 -->
      <div class="mb-16">
        <div class="flex items-center justify-between mb-6">
          <h2 class="text-3xl font-bold">スクラップ買取</h2>
          <router-link to="/scrap" class="flex items-center text-[#81C784] hover:text-[#2E7D32] transition-colors duration-300">
            <span class="mr-2">More</span>
            <i class="fas fa-chevron-right text-sm"></i>
          </router-link>
        </div>
        <div class="grid md:grid-cols-4 gap-6">
          <div v-for="scrap in scrapList" :key="scrap.id" class="rounded-lg overflow-hidden shadow-lg group hover:shadow-xl transition-shadow duration-300">
            <img :src="require(`@/assets/${scrap.image}`)" class="w-full h-48 object-cover" :alt="scrap.name" />
            <div class="p-4 bg-white relative">
              <div class="flex justify-between items-center mb-2">
                <h3 class="text-lg font-semibold">{{ scrap.name }}</h3>
              </div>
              <p v-if="scrap.remark" class="text-gray-600 mt-2">{{ scrap.remark }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- その他買取 -->
      <div class="mb-16">
        <div class="flex items-center justify-between mb-6">
          <h2 class="text-3xl font-bold">その他買取</h2>
          <router-link to="/used" class="flex items-center text-[#81C784] hover:text-[#2E7D32] transition-colors duration-300">
            <span class="mr-2">More</span>
            <i class="fas fa-chevron-right text-sm"></i>
          </router-link>
        </div>
        <div class="grid md:grid-cols-4 gap-6">
          <div v-for="other in otherList" :key="other.id" class="rounded-lg overflow-hidden shadow-lg group hover:shadow-xl transition-shadow duration-300">
            <img :src="require(`@/assets/${other.image}`)" class="w-full h-48 object-cover" :alt="other.name" />
            <div class="p-4 bg-white relative">
              <div class="flex justify-between items-center mb-2">
                <h3 class="text-lg font-semibold">{{ other.name }}</h3>
              <p v-if="other.remark" class="text-gray-600 mt-2">{{ other.remark }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- アクセスマップ -->
      <div class="mb-16">
        <div class="mb-12">
          <h2 class="text-3xl font-bold">アクセスマップ</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2">
          <div class="w-full h-[400px]">
            <iframe src="https://www.google.com/maps/embed?pb=!4v1753493786322!6m8!1m7!1sHvwqw1rp9kqtMqRPuX2I4g!2m2!1d35.22738806181388!2d136.2545189273164!3f57.39505140085375!4f-4.89573359172617!5f0.4000000000000002" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
          <div>
            <div class="w-full h-[400px]">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d814.7893582731122!2d136.2539340696425!3d35.2274507938026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6003d4492a6ff2a1%3A0xdbfe961f0b6a5ed1!2z6YeR5a2Q5ZWG5LqLKOagqik!5e0!3m2!1sja!2sjp!4v1753493738525!5m2!1sja!2sjp" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { getNewsList } from '@/api/news';
import 'swiper/css/swiper.css';

export default {
  name: 'HomeView',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      newsLoading: true,
      newsError: null,
      notices: [],
      scrapList: [],
      otherList: [],

      swiperOption: {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      bannerSlides: [
        {
          image: require('@/assets/img/banner1.jpg'),
          title: '高額の価格、迅速な対応',
          description: '経験豊富なスタッフが丁寧に対応いたします'
        },
        {
          image: require('@/assets/img/banner2.png'),
          title: '安心・信頼のサービス',
          description: '最高品質のリサイクルサービスを提供'
        },
        {
          image: require('@/assets/img/banner3.webp'),
          title: '幅広いの買取',
          description: '鉄くずや非鉄金属、雑品、機械屑など様々な金属スクラップの買取を行っています。'
        }
      ],
    };
  },
  computed: {
    latestNotices() {
      return this.notices.slice(0, 3);
    }
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).replace(/\//g, '-');
    },
    getscrapRoute(name) {
      const routeMap = {
        'スクラップ買取': '/scrap',
        '中古買取': '/used',
        '出張買取': '/visit',
        '片付け・遺品整理': '/tidying'
      };
      return routeMap[name] || '/';
    },
    async fetchNews() {
      try {
        this.newsLoading = true;
        this.newsError = null;
        const data = await getNewsList();
        if (Array.isArray(data)) {
          this.notices = data;
        } else {
          console.error('Invalid news data format:', data);
          this.newsError = 'お知らせの取得に失敗しました';
        }
      } catch (err) {
        console.error('Failed to fetch news:', err);
        this.newsError = err.message || 'お知らせの取得に失敗しました';
      } finally {
        this.newsLoading = false;
      }
    },
    fetchScrapList() {
      this.scrapList = [
        {
            "id": 1,
            "name": "鉄くず",
            "description": "鉄スクラップの種類や品質に応じて適切な価格で買取いたします。",
            "image": "img/scraps/type7.jpg"
        },
        {
            "id": 2,
            "name": "銅・真鍮・砲金系",
            "description": "銅、真鍮などの非鉄金属を高価買取いたします。建設現場や工場からの発生品など、さまざまな形態での買取に対応しています。",
            "image": "img/scraps/1-03.jpg"
        },
        {
            "id": 3,
            "name": "電線系",
            "description": "電線・ケーブル類を種類別に高価買取いたします。被覆の有無や種類によって買取価格が異なります。",
            "image": "img/scraps/type2.jpg"
        },
        {
            "id": 4,
            "name": "アルミ・ステンレス系",
            "description": "アルミニウムやステンレスなど、各種非鉄金属を買取いたします。形状や純度によって買取価格が変動します。",
            "image": "img/scraps/type3.jpg"
        }
      ];
    },
    fetchOtherList() {
      this.otherList = [
        {
            "id": 1,
            "name": "磁器",
            "image": "img/other/other1.jpg"
        },
        {
            "id": 2,
            "name": "羽毛布団",
            "image": "img/other/other3.png"
        },
      ];
    }
  },
  created() {
    window.scrollTo(0, 0);
    this.fetchNews();
    this.fetchScrapList();
    this.fetchOtherList();
  }
};
</script>
<style scoped>
.swiper-container {
  height: 100%;
  width: 100%;
}

.swiper-pagination-bullet {
  background: white !important;
  opacity: 0.6;
}

.swiper-pagination-bullet-active {
  background: white !important;
  opacity: 1;
}

/* Responsive text sizes */
@media (max-width: 768px) {
  .text-4xl {
    font-size: 2rem;
  }

  .text-xl {
    font-size: 1.1rem;
  }
}
</style>